import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=1cf32c4c"
import script from "./qr.vue?vue&type=script&lang=js"
export * from "./qr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports